import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useMedplum } from '@medplum/react'
import { notifications } from '@mantine/notifications'
import { config } from '@/config'
import { faxSentQueryKey } from './useFaxSent'

export function useDeleteSentFax(messageId: string) {
  const medplum = useMedplum()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const res = await fetch(`${config.middlewareUrl}/order/sent-faxes/${messageId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${medplum.getAccessToken()}` },
      })
      if (!res.ok) throw new Error(`Failed to delete sent fax: ${res.status}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: faxSentQueryKey() })
      queryClient.invalidateQueries({ queryKey: ['sent-fax-detail', messageId] })
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: faxSentQueryKey() })
      queryClient.invalidateQueries({ queryKey: ['sent-fax-detail', messageId] })
      notifications.show({
        color: 'red',
        title: 'Delete failed',
        message: 'Failed to delete the fax. Please try again.',
      })
    },
  })
}
